if (!window.nelkoProductGridSwatchesReady) {
    window.nelkoProductGridSwatchesReady = true
    document.addEventListener('click', handleNelkoProductCardSwatchClick)
    document.addEventListener('keydown', handleNelkoProductCardSwatchKeydown)
  }
  
  /**
   * 获取事件命中的产品卡颜色选项。
   * @param {EventTarget | null} target 事件目标
   * @returns {Element | null}
   */
  function getNelkoProductCardSwatch(target) {
    if (!(target instanceof Element)) {
      return null
    }
  
    return target.closest('[data-product-card-swatch]')
  }
  
  /**
   * 处理产品卡颜色选项点击。
   * @param {MouseEvent} event 点击事件
   */
  function handleNelkoProductCardSwatchClick(event) {
    var swatch = getNelkoProductCardSwatch(event.target)
  
    if (!swatch) {
      return
    }
  
    event.preventDefault()
    event.stopPropagation()
  
    updateNelkoProductCardBySwatch(swatch)
  }
  
  /**
   * 处理产品卡颜色选项键盘操作。
   * @param {KeyboardEvent} event 键盘事件
   */
  function handleNelkoProductCardSwatchKeydown(event) {
    var swatch = getNelkoProductCardSwatch(event.target)
  
    if (!swatch || (event.key !== 'Enter' && event.key !== ' ')) {
      return
    }
  
    event.preventDefault()
    event.stopPropagation()
  
    updateNelkoProductCardBySwatch(swatch)
  }
  
  /**
   * 根据颜色选项更新产品卡图片与选中态。
   * @param {Element} swatch 颜色选项节点
   */
  function updateNelkoProductCardBySwatch(swatch) {
    if (swatch.getAttribute('aria-disabled') === 'true') {
      return
    }
  
    var card = swatch.closest('.nelko-product-card')
  
    if (!card) {
      return
    }
  
    updateNelkoProductCardImage(card, swatch)
    updateNelkoProductCardSwatchState(card, swatch)
  }
  
  /**
   * 更新产品卡主图。
   * @param {Element} card 产品卡节点
   * @param {Element} swatch 颜色选项节点
   */
  function updateNelkoProductCardImage(card, swatch) {
    var media = card.querySelector('[data-product-card-media-image]')
    var image = media ? media.querySelector('img') : null
    var imageSrc = swatch.getAttribute('data-image-src')
  
    if (!image || !imageSrc) {
      return
    }
  
    image.src = imageSrc
  
    var imageSrcset = swatch.getAttribute('data-image-srcset')
    if (imageSrcset) {
      image.srcset = imageSrcset
    } else {
      image.removeAttribute('srcset')
    }
  
    var imageWidth = Number(swatch.getAttribute('data-image-width'))
    var imageHeight = Number(swatch.getAttribute('data-image-height'))
    if (imageWidth > 0) {
      image.width = imageWidth
    }
    if (imageHeight > 0) {
      image.height = imageHeight
    }
  
    var imageAlt = swatch.getAttribute('data-image-alt')
    if (imageAlt !== null) {
      image.alt = imageAlt
    }
  }
  
  /**
   * 更新产品卡颜色选中态。
   * @param {Element} card 产品卡节点
   * @param {Element} activeSwatch 当前选中的颜色选项
   */
  function updateNelkoProductCardSwatchState(card, activeSwatch) {
    var swatches = card.querySelectorAll('[data-product-card-swatch]')
  
    swatches.forEach((swatch) => {
      var isActive = swatch === activeSwatch
  
      swatch.classList.toggle('is-active', isActive)
      swatch.setAttribute('aria-pressed', isActive ? 'true' : 'false')
    })
  }
  